module.exports = __webpack_public_path__ + "lib/38R2qW64.svg";